// extracted by mini-css-extract-plugin
module.exports = {"label":"NavigationItem_label__UdCDD"};